import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { COLOR_CODES_FABRIC, MATERIAL_OPTIONS, ROOM_OPTIONS } from 'commons/constants';
import ColorsFilter from 'components/essentials/ColorsFilter';
import TogglePillGroup from 'components/consumer/TogglePillGroup';
import ToggleButtonGroup from 'components/consumer/ToggleButtonGroup';
import ShopByHeaderSection from 'components/consumer/ShopByHeaderSection';
const colorsList = COLOR_CODES_FABRIC.map(obj => Object.keys(obj)[0]);
const InspirationFiltersTop = t0 => {
  const $ = _c(17);
  const {
    filterState,
    filterActions
  } = t0;
  let t1;
  if ($[0] !== filterActions || $[1] !== filterState.materialFilter) {
    t1 = MATERIAL_OPTIONS.map(option => ({
      label: option.label,
      id: option.value,
      isSelected: filterState.materialFilter === option.value,
      onClick: () => {
        filterActions.setMaterialFilter(filterState.materialFilter === option.value ? "" : option.value);
      }
    }));
    $[0] = filterActions;
    $[1] = filterState.materialFilter;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const materialItems = t1;
  let t2;
  if ($[3] !== filterActions || $[4] !== filterState.roomFilter) {
    t2 = ROOM_OPTIONS.map(option_0 => ({
      label: option_0.label,
      id: option_0.value,
      isSelected: filterState.roomFilter === option_0.value,
      onClick: () => {
        filterActions.setRoomFilter(filterState.roomFilter === option_0.value ? "" : option_0.value);
      }
    }));
    $[3] = filterActions;
    $[4] = filterState.roomFilter;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const roomItems = t2;
  let t3;
  if ($[6] !== materialItems) {
    t3 = <ShopByHeaderSection label="Material"><ToggleButtonGroup items={materialItems} tabIndex="0" /></ShopByHeaderSection>;
    $[6] = materialItems;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== filterActions.toggleColorFilter || $[9] !== filterState.colorFilters) {
    t4 = <ShopByHeaderSection label="Color"><ColorsFilter colors={colorsList} selectedColors={filterState.colorFilters} onSelectColor={filterActions.toggleColorFilter} variant="ShopByHeaderSection" /></ShopByHeaderSection>;
    $[8] = filterActions.toggleColorFilter;
    $[9] = filterState.colorFilters;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== roomItems) {
    t5 = <ShopByHeaderSection label="Shop by Room"><TogglePillGroup items={roomItems} variant="ShopByHeaderSection" /></ShopByHeaderSection>;
    $[11] = roomItems;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
    t6 = <>{t3}{t4}{t5}</>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};
InspirationFiltersTop.propTypes = {
  filterState: PropTypes.object.isRequired,
  filterActions: PropTypes.object.isRequired
};
export default InspirationFiltersTop;